import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BaasicTable, TableFilter, EmptyState, QueryDropdown, BasicQueryCheckbox } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';

function ImportReferenceListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        routes,
        downloadUrl,
        authorization,
        importReferenceTypeStore,
        insuranceStore,
        inactiveQueryCheckboxStore
    } = listViewStore;
    return (
        <ApplicationListLayout store={listViewStore}>
            <PageNavigation>
                <BaasicButton className="btn btn--base btn--primary" label={'Download'} icon='u-icon u-icon--sml u-icon--download--white' onClick={() => { window.open(downloadUrl, "_blank"); }}></BaasicButton>               
                <BaasicButton className="btn btn--base btn--primary" label={'Upload'} icon='u-icon u-icon--sml u-icon--upload--white' onClick={() => { routes.upload() }}></BaasicButton>               
                <BaasicButton className="btn btn--base btn--primary"  label={'LIST_LAYOUT.CREATE_BUTTON'} onClick={() => routes.create()} authorized={authorization ? authorization.create : true}></BaasicButton>
            </PageNavigation>
            <Content  emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={insuranceStore} propertyName="insuranceId" label="Insurance Name" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown id={'referenceTypes'} queryUtility={queryUtility} propertyName={'referenceTypeIds'} label={'Reference Type'} store={importReferenceTypeStore} clearable={false} />
                        </div>
                        <div className="col form__group u-flex--self--center">
                        <BasicQueryCheckbox id={'inActive'} queryUtility={queryUtility} propertyName={'inActive'} label={'Show inactive'} store={inactiveQueryCheckboxStore}/>
                    </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='IMPORT_REFERENCE.LIST.EMPTY_STATE.TITLE' description='IMPORT_REFERENCE.LIST.EMPTY_STATE.DESCRIPTION' />
}

ImportReferenceListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(ImportReferenceListTemplate);
